module.exports = __webpack_public_path__ + "resources/img/img_ngs.efa11814ef13f67af88183e4b4d9e215.png";